var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpt-chat-circle-loading relative rounded-full",style:({
    width: _vm.size + 'px',
    height: _vm.size + 'px',
  })},[_c('div',{staticClass:"loading-item rounded-full"})])
}
var staticRenderFns = []

export { render, staticRenderFns }